import ApiResourceManager from '../ApiResourceManager';
import { buildFavouriteTogglePayload } from '../transforms';

export default class ProductsManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/products',
      params,
    });

  show = (id) =>
    this.request({
      method: 'GET',
      url: `/products/${id}`,
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/products',
      data,
    });

  update = (id, data) =>
    this.request({
      method: 'POST',
      url: `/products/${id}`,
      data,
    });

  delete = (ids, isMaster) =>
    this.request({
      method: 'DELETE',
      url: '/products',
      data: {
        ids,
        is_master: isMaster,
      },
    });

  reorder = (categoryId, ids) =>
    this.request({
      method: 'PUT',
      url: `/categories/${categoryId}/products-order`,
      data: {
        ids,
      },
    });

  toggleAvailable = (productId, isAvailable) =>
    this.request({
      method: 'PATCH',
      url: `/products/${productId}`,
      data: {
        fields: ['is_available'],
        is_available: isAvailable,
      },
    });

  toggleVisible = (productId, isVisible) =>
    this.request({
      method: 'PATCH',
      url: `/products/${productId}`,
      data: {
        fields: ['is_visible'],
        is_visible: isVisible,
      },
    });

  toggleAvailableForPickup = (productId, isAvailable) =>
    this.request({
      method: 'PATCH',
      url: `/products/${productId}`,
      data: {
        fields: ['is_available_for_pickup'],
        is_available_for_pickup: isAvailable,
      },
    });

  toggleAvailableForDelivery = (productId, isAvailable) =>
    this.request({
      method: 'PATCH',
      url: `/products/${productId}`,
      data: {
        fields: ['is_available_for_delivery'],
        is_available_for_delivery: isAvailable,
      },
    });

  toggleFavourite = (product, favourites) => this.update(product.id, buildFavouriteTogglePayload(product, favourites));
}
